export const currencyRate = ( methodPayment, rateCurrency ) => {
    const nameCurrencyMap = {
        "Crypto": "USDT_UAH",
        "MasterCard EU": "EUR_UAH"
    };

    // USD-priced methods (skins, etc.) don't have their own USD_UAH pair on the
    // backend, so they piggyback on the USDT rate since USDT tracks USD 1:1.
    const currencyPairMap = {
        "USD": "USDT_UAH",
        "USDT": "USDT_UAH",
        "EUR": "EUR_UAH"
    };

    const currencyPair = nameCurrencyMap[methodPayment?.name]
        ?? currencyPairMap[methodPayment?.currency]
        ?? null;

    const rateObj = currencyPair ? rateCurrency?.find(obj => obj.pair === currencyPair) : null;
    return rateObj?.lastPrice || 1;
}
